/* eslint-disable no-bitwise */
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import {
  Container, Row, Col, Button,
  Modal, ModalHeader, ModalBody, ModalFooter,
  FormGroup, Label, Input,
  Card, CardBody, Badge, Spinner,
} from 'reactstrap'
import moment from 'moment'
import PdfRender from '../../../components/Common/PdfReader'
import MaskedInput from '../../../components/Template/Input/MaskedInput'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import { updateSolicitation } from '../../../store/ducks/humanResources'
import { history } from '../../../store'

class ReplySolicitation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      solicitation: null,
      reason: '',
      reasonInputError: '',
      reasonDialogIsOpen: false,
      fileNumber: 0,
    }
  }

  componentDidMount() {
    if (this.props.location.state && this.props.location.state.solicitation) {
      const { solicitation } = this.props.location.state

      if (solicitation) {
        this.setState({ solicitation })
      }
    } else {
      history.push('/gerencia/solicitacoes')
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps?.humanResources?.updateSolicitationIsLoading !== this.props?.humanResources?.updateSolicitationIsLoading
      && !this.props?.humanResources?.updateSolicitationIsLoading
      && !this.props?.humanResources?.updateSolicitationError
    ) {
      if (this.props?.location?.state?.solicitation) {
        this.setState({
          solicitation: this.props.location.state.solicitation,
          reason: '',
          reasonInputError: '',
          reasonDialogIsOpen: false,
          fileNumber: 0,
        })
        window.scrollTo(0, 0)
      }
    }
  }

  formatStatus = status => {
    switch (status) {
      case '0':
        return <Badge className="badge-soft-info mr-1">Em aberto</Badge>
      case '1':
        return <Badge className="badge-soft-success mr-1">Aprovada</Badge>
      case '2':
        return <Badge className="badge-soft-danger mr-1">Recusada</Badge>
      default:
        return null
    }
  }

  render() {
    const { solicitation } = this.state
    const { updateSolicitation } = this.props
    const { reason, reasonDialogIsOpen, reasonInputError, fileNumber } = this.state
    //const { isManager } = this.props.auth.user
    const { updateSolicitationIsLoading } = this.props.humanResources

    //if (!isManager) return <Redirect to="/" />

    if (!solicitation) return null

    let openSolicitations = []
    if (this.props?.location?.state?.openSolicitations?.length > 0) {
      openSolicitations = this.props?.location?.state?.openSolicitations
        .filter(item => item.pend_id !== solicitation.pend_id)

      console.tron.log('openSolicitations reply', openSolicitations)
    }

    let nextSolicitation
    if (openSolicitations.length > 0) {
      nextSolicitation = openSolicitations[openSolicitations.length - 1]
    }

    console.tron.log('nextSolicitation reply', nextSolicitation)

    return (
      <div className="page-content">
        <Modal
          centered
          isOpen={reasonDialogIsOpen}
          toggle={() => {
            if (updateSolicitationIsLoading) return
            this.setState({ reasonDialogIsOpen: !reasonDialogIsOpen })
          }}
        >
          <ModalHeader
            toggle={() => {
              if (updateSolicitationIsLoading) return
              this.setState({ reasonDialogIsOpen: !reasonDialogIsOpen })
            }}
          >
            Recusar solicitação
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>Motivo</Label>
              <Input
                className="form-control"
                type="text"
                autoCapitalize="sentences"
                maxLength={500}
                value={reason}
                onChange={e => this.setState({
                  reason: e.target.value,
                  reasonInputError: '',
                })}
              />
              {reasonInputError && <span style={{ color: 'red' }}>{reasonInputError}</span>}
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              color="light"
              disabled={updateSolicitationIsLoading}
              onClick={() => this.setState({ reasonDialogIsOpen: !reasonDialogIsOpen })}
            >
              Voltar
            </Button>
            <Button
              type="button"
              color="danger"
              disabled={updateSolicitationIsLoading}
              onClick={() => {
                if (!reason) return this.setState({ reasonInputError: 'Campo obrigatório.' })
                return updateSolicitation({
                  type: 2,
                  solicitation: {
                    ...solicitation,
                    reason,
                  },
                  openSolicitations,
                  nextSolicitation,
                })
              }}
            >
              Recusar
              {reasonDialogIsOpen && updateSolicitationIsLoading && (
                <Spinner size="sm" className="ml-2" />
              )}
            </Button>
          </ModalFooter>
        </Modal>

        <Container fluid>
          <Row>
            <Col className="d-flex">
              <Breadcrumbs
                title="Solicitação"
                breadcrumbItems={[]}
              />
              <div
                style={{
                  marginTop: 13,
                  marginLeft: 14,
                }}
              >
                <Badge className="badge-soft-dark mr-1">
                  #
                  {solicitation.pend_id}
                </Badge>
              </div>
              <div
                style={{
                  marginTop: 13,
                  marginLeft: 10,
                }}
              >
                {this.formatStatus(solicitation.pend_aprov)}
              </div>
            </Col>
          </Row>

          <Row>
            <Col xl={4} lg={4} md={4} sm={4}>
              <div
                className="d-flex align-items-end"
                style={{ height: 29, marginBottom: 12 }}
              >
                <span style={{ fontWeight: 600 }}>
                  Informações
                </span>
              </div>

              <Card>
                <CardBody>
                  {/* Comum a todos */}

                  <FormGroup>
                    <Label>Data de solicitação</Label>
                    <Input
                      disabled
                      value={moment(solicitation.pend_dt_sol).format('DD/MM/YYYY')}
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label>Assunto</Label>
                    <Input
                      disabled
                      value={solicitation.pend_assunto}
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label>Solicitante</Label>
                    <Input
                      disabled
                      value={solicitation.pend_colaborador}
                    />
                  </FormGroup>

                  {/* Despesas */}

                  {solicitation.pend_assunto === 'Despesa' && (
                    <>
                      <FormGroup>
                        <Label>Rubrica</Label>
                        <Input
                          disabled
                          value={solicitation.rubrica_nome}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label>Descrição</Label>
                        <Input
                          disabled
                          value={solicitation.mov_desc}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label>Valor</Label>
                        <MaskedInput
                          disabled
                          mask="R$ num"
                          lazy={false}
                          value={solicitation.mov_vlr}
                          blocks={{
                            num: {
                              mask: Number,
                              thousandsSeparator: '.',
                            },
                          }}
                        />
                      </FormGroup>
                    </>
                  )}

                  {/* Ponto retroativo */}

                  {solicitation.pend_assunto === 'Retroativo' && (
                    <>
                      <FormGroup>
                        <Label>Data do expediente retroativo</Label>
                        <Input
                          disabled
                          value={moment(solicitation.pend_dt).format('DD/MM/YYYY')}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label>Setor ou Projeto</Label>
                        <Input
                          disabled
                          value={solicitation.proj_nome}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label>Atividade ou Produto</Label>
                        <Input
                          disabled
                          value={solicitation.pontoAtiv_ativ}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label>Descrição</Label>
                        <Input
                          disabled
                          value={solicitation.pontoAtiv_desc}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label>Tempo dedicado</Label>
                        <Input
                          disabled
                          value={solicitation.pontoAtiv_tempo}
                        />
                      </FormGroup>
                    </>
                  )}

                  {/* Férias */}

                  {solicitation.pend_assunto === 'Férias' && (
                    <>
                      <FormGroup>
                        <Label>Data de início</Label>
                        <Input
                          disabled
                          value={moment(solicitation.pend_dt_ini).format('DD/MM/YYYY')}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label>Data de encerramento</Label>
                        <Input
                          disabled
                          value={moment(solicitation.pend_dt_fim).format('DD/MM/YYYY')}
                        />
                      </FormGroup>
                    </>
                  )}

                  {/* Atestado/Ausência */}

                  {solicitation.pend_assunto === 'Atestado' && (
                    <>
                      <FormGroup>
                        <Label>Data inicial</Label>
                        <Input
                          disabled
                          value={moment(solicitation.pend_dt_ini).format('DD/MM/YYYY')}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label>Data final</Label>
                        <Input
                          disabled
                          value={moment(solicitation.pend_dt_fim).format('DD/MM/YYYY')}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label>Descrição</Label>
                        <Input
                          disabled
                          value={solicitation.pontoAtiv_justif}
                        />
                      </FormGroup>
                    </>
                  )}

                  {/* Comum à todos */}

                  <FormGroup>
                    <Label>Justificativa</Label>
                    <Input
                      disabled
                      value={solicitation.pend_justif}
                    />
                  </FormGroup>
                </CardBody>
              </Card>

            </Col>

            <Col>
              <div
                className="d-flex align-items-end justify-content-between"
                style={{ height: 29, marginBottom: 12 }}
              >
                <div>
                  <span style={{ fontWeight: 600 }}>
                    Anexos
                  </span>
                  {solicitation.files && solicitation.files.length > 0 && (
                    <span style={{ fontWeight: 600 }}>
                      {` (${fileNumber + 1} de ${solicitation.files.length})`}
                    </span>
                  )}
                </div>
                <div className="d-flex">
                  {solicitation.files && solicitation.files.length > 0 && (
                    <>
                      <Button
                        disabled={fileNumber === 0}
                        size="sm"
                        color="info"
                        className="ml-4"
                        onClick={() => this.setState({ fileNumber: fileNumber - 1 })}
                      >
                        <i className="ri-arrow-left-s-line font-size-10" />
                        {' '}
                        Anterior
                      </Button>
                      <Button
                        disabled={fileNumber + 1 === solicitation.files.length}
                        size="sm"
                        color="info"
                        className="ml-2"
                        onClick={() => this.setState({ fileNumber: fileNumber + 1 })}
                      >
                        Próximo
                        {' '}
                        <i className="ri-arrow-right-s-line font-size-10" />
                      </Button>
                    </>
                  )}
                </div>
              </div>

              <Card>
                <Col className="d-flex align-items-center justify-content-center p-3">
                  {(!solicitation.files || solicitation.files.length <= 0) && (
                    <span style={{ padding: 25 }}>Esta solicitação não possui anexos.</span>
                  )}
                  {solicitation.files && solicitation.files.length > 0 && solicitation.files[fileNumber].extension === 'pdf' && (
                    <PdfRender data={`https://oikos.ecoss.is/oikos/${solicitation.files[fileNumber].path}`} />
                  )}
                  {
                    solicitation.files
                    && solicitation.files.length > 0
                    && (
                      solicitation.files[fileNumber].extension === 'png'
                      || solicitation.files[fileNumber].extension === 'jpg'
                      || solicitation.files[fileNumber].extension === 'jpeg'
                    )
                    && (
                      <img
                        src={`https://oikos.ecoss.is/oikos/${solicitation.files[fileNumber].path}`}
                        alt="Imagem anexa à solicitação"
                        style={{ maxHeight: 514, maxWidth: 800 }}
                      />
                    )
                  }
                </Col>
              </Card>
            </Col>
          </Row>

          {solicitation.pend_aprov === '0' && (
            <>
              <Row>
                <Col>
                  <hr className="mt-2 mb-4" />
                </Col>
              </Row>

              <Row>
                <Col className="d-flex justify-content-end">
                  {!nextSolicitation && (
                    <>
                      <Button
                        type="button"
                        color="danger"
                        onClick={() => this.setState({ reasonDialogIsOpen: true })}
                      >
                        Recusar
                      </Button>
                      <Button
                        type="button"
                        color="primary"
                        className="ml-3"
                        disabled={reasonDialogIsOpen || updateSolicitationIsLoading}
                        onClick={() => updateSolicitation({
                          type: 1,
                          solicitation,
                          openSolicitations: false,
                          nextSolicitation: false,
                        })}
                      >
                        Aprovar
                        {!reasonDialogIsOpen && updateSolicitationIsLoading && (
                          <Spinner size="sm" className="ml-2" />
                        )}
                      </Button>
                    </>
                  )}

                  {nextSolicitation && (
                    <>
                      <Button
                        type="button"
                        color="danger"
                        disabled={reasonDialogIsOpen || updateSolicitationIsLoading}
                        onClick={() => this.setState({ reasonDialogIsOpen: true })}
                      >
                        Recusar e ver próxima
                      </Button>
                      <Button
                        type="button"
                        color="primary"
                        className="ml-3"
                        disabled={reasonDialogIsOpen || updateSolicitationIsLoading}
                        onClick={() => updateSolicitation({
                          type: 1,
                          solicitation,
                          openSolicitations,
                          nextSolicitation,
                        })}
                      >
                        Aprovar e ver próxima
                        {!reasonDialogIsOpen && updateSolicitationIsLoading && (
                          <Spinner size="sm" className="ml-2" />
                        )}
                      </Button>
                    </>
                  )}
                </Col>
              </Row>
            </>
          )}
        </Container>
      </div>
    )
  }
}

const mapStateToProps = state => ({ auth: state.auth, humanResources: state.humanResources })
const mapDispatchToProps = dispatch => bindActionCreators({ updateSolicitation }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(ReplySolicitation)
